import { useQuery } from "@tanstack/react-query";
import { coamAreaApi } from "../../geospatial/api/coamArea";

export const useFetchNetworkBoundries = () => {

    const { data, error, isLoading, isError } = useQuery({
        queryKey: ["network-boundaries"],
        queryFn: () => coamAreaApi.fetchCoamAreas(),
    });

    return {
        networkBoundaries: data?.data?.features || [],
        isLoading,
        isError,
        error,
    };

};